import React, { Fragment, Component } from 'react'
import * as R from 'ramda'

import Button from '../../../UniformComponents/Button'
import Select from '../../form/Select'

class LicenceProduct extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showOptions: false,
        }
    }

    toggleOptions = () => {
        const { showOptions } = this.state

        this.setState({
            showOptions: !showOptions,
        })
    }

    cancel = () => {
        Reflect.deleteProperty(this, 'productStatus')
        Reflect.deleteProperty(this, 'emailLimit')

        this.setState({
            showOptions: false,
        })
    }

    save = async () => {
        const { product, licenceManagerStore } = this.props
        const { store } = licenceManagerStore
        const { productId, status, emailLimit } = product

        product.status = R.pathOr(status, ['productStatus'], this)
        product.emailLimit = R.pathOr(emailLimit, ['emailLimit'], this)

        try {
            await licenceManagerStore.saveProduct(product)
            store.addNotification({ body: `Product (${productId}) updated`, level: 'success' })
            this.toggleOptions()
        } catch (e) {
            console.error(e)
            store.handleError({ body: `Error updating product (${productId})`, level: 'error' })
            this.cancel()
        }
    }

    changeStatus = ({ value }) => {
        this.productStatus = value
    }

    changeEmailLimit = ({ target }) => {
        const emailLimit = parseInt(target.value, 10)
        this.emailLimit = emailLimit
    }

    render() {
        const { showOptions } = this.state
        const { product, licenceManagerStore } = this.props
        const { productStatuses, getProductStatusLabel } = licenceManagerStore
        const { name, status, emailLimit } = product

        return (
            <li style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                {name}
                <span onDoubleClick={this.toggleOptions}>
                    {`[${getProductStatusLabel(status)}]`}
                </span>
                {(showOptions && (
                    <Fragment>
                        <Select
                            options={productStatuses}
                            defaultValue={status}
                            onBlur={this.changeStatus}
                        />
                        <input
                            type="text"
                            defaultValue={emailLimit}
                            className="form-input"
                            onBlur={this.changeEmailLimit}
                        />
                        <Button
                            label="Save"
                            cssClass="regular primary"
                            onClick={this.save}
                        />
                        <Button
                            label="Cancel"
                            cssClass="regular primary"
                            onClick={this.cancel}
                        />
                    </Fragment>
                ))}
            </li>
        )
    }
}

export default LicenceProduct
